import isEmpty from 'lodash.isempty';
import { changesDigitalData } from '@/utils/digitalData';

const useUser = () => {
  const transformUser = (user) => {
    let resultUser = {
      hasTransacted: false,
      isLoggedIn: false,
    };

    if (window?.digitalData?.user) {
      resultUser = { ...window.digitalData.user, ...resultUser };
    }

    if (user && !isEmpty(user)) {
      resultUser = {
        ...resultUser,
        birthDate: user.birthAt ? user.birthAt.replace('T00:', 'T01:') : '',
        email: user.email,
        firstName: user?.firstName ?? '',
        isLoggedIn: true,
        isSubscribed: !!(user.relationships?.subscription || []).length,
        lastName: user?.lastName || '',
        phone: user?.phone || '',
        userId: user.id,
        registrationDate: user.registeredAt ? new Date(user.registeredAt).toISOString() : '',
        segment: {
          userStatus: user.relationships?.userLoyalty?.percentCashback || '',
          userType: user.isAdmin ? 'administrator' : 'user',
        },
        lastTransactionDate: '',
      };
    }

    return resultUser;
  };

  const changeUser = (user) => {
    changesDigitalData(['user', transformUser(user), 'book24']);
  };
  return { transformUser, changeUser };
};

export default useUser;
